import { MyApp } from '../../types/myAppTypes';
import { BaseApplicationProperty } from './updateApplication/BaseApplicationProperty';
import {
  AppGroup,
  InformationClassificationPolicyProperty,
  ServiceDomainProperty,
} from './updateApplication';
import { AddFunctionalAreaConnectionProperty } from './functionalArea';
import { RoleProperty } from './responsibilities';
import { OwnerProperty } from './updateApplication/OwnerProperty';

export type SelectedAppType = MyApp & {
  currentValue?: string;
  newValue?: string;
  field?: string;
};

export enum SelectFieldOptions {
  APP_GROUP = 'appGroup',
  FUNCTIONAL_AREA = 'functionalArea',
  INFORMATION_CLASSIFICATION_POLICY = 'informationClassificationPolicy',
  OWNER = 'owner',
  ROLES = 'roles',
  SERVICE_DOMAIN = 'serviceDomain',
}

export type SelectFieldOptionItem = {
  label: string;
  value: string;
  property: BaseApplicationProperty;
};

const selectFieldOptions = [
  {
    label: 'App Group',
    value: SelectFieldOptions.APP_GROUP,
    PropertyClass: AppGroup,
  },
  {
    label: 'Functional Area',
    value: SelectFieldOptions.FUNCTIONAL_AREA,
    PropertyClass: AddFunctionalAreaConnectionProperty,
  },
  {
    label: 'Information Classification Policy',
    value: SelectFieldOptions.INFORMATION_CLASSIFICATION_POLICY,
    PropertyClass: InformationClassificationPolicyProperty,
  },
  {
    label: 'Owner',
    value: SelectFieldOptions.OWNER,
    PropertyClass: OwnerProperty,
  },
  {
    label: 'Domain',
    value: SelectFieldOptions.SERVICE_DOMAIN,
    PropertyClass: ServiceDomainProperty,
  },
  {
    label: 'Role',
    value: SelectFieldOptions.ROLES,
    PropertyClass: RoleProperty,
  },
];

/**
 * List of select field options with their labels, values, and properties.
 */
export const SelectFieldOptionsList = selectFieldOptions.map(option => ({
  label: option.label,
  value: option.value,
  property: new option.PropertyClass(option.value),
}));
